import { json } from "@hyper-hyper-space/hhs3_json";
import { parseRowFieldTerm } from "./payload.js";
export function formatPredicate(pred, scope = {}) {
    switch (pred.p) {
        case 'true':
            return 'true';
        case 'false':
            return 'false';
        case 'exists': {
            const existsTable = pred.table;
            const isSelfRef = scope.gatedTable !== undefined && existsTable === scope.gatedTable;
            const alias = isSelfRef ? selfReferentialExistsAlias(existsTable) : undefined;
            const existsRef = alias !== undefined ? `${existsTable} AS ${alias}` : existsTable;
            const existsQual = alias !== null && alias !== void 0 ? alias : existsTable;
            const where = pred.where !== undefined
                ? ` WHERE ${Object.entries(pred.where).map(([k, v]) => `${formatExistsWhereKey(k, existsQual)} = ${formatExistsWhereValue(v, scope.gatedTable)}`).join(' AND ')}`
                : '';
            return `EXISTS ${existsRef}${where}`;
        }
        case 'cmp':
            return `${formatOperand(pred.left, scope.gatedTable, false)} ${formatCmp(pred.cmp)} ${formatOperand(pred.right, scope.gatedTable, false)}`;
        case 'str':
            return `${formatOperand(pred.value, scope.gatedTable, false)} LIKE ${formatStringPattern(pred.str, pred.sub)}`;
        case 'and':
            return pred.args.map((a) => formatPredicate(a, scope)).join(' AND ');
        case 'or':
            return pred.args.map((a) => formatPredicate(a, scope)).join(' OR ');
    }
}
export function formatRestrictionFailureReason(table, op, rule) {
    return `${table} ${op.action} on row '${op.rowId}' does not satisfy ALLOW ${op.action} IF ${formatPredicate(rule, { gatedTable: table })}`;
}
export function formatRowNotLiveFailureReason(table, op) {
    return `${table} ${op.action} on row '${op.rowId}': rowId is not live in table '${table}'`;
}
function selfReferentialExistsAlias(tableName) {
    const letter = tableName[0];
    return tableName.length === 1 ? `${letter}2` : letter;
}
function formatExistsWhereKey(key, existsQual) {
    return `${existsQual}.${key}`;
}
function formatExistsWhereValue(value, gatedTable) {
    if (typeof value === 'string' && value === '$author')
        return '$author';
    if (typeof value === 'string') {
        const col = parseRowFieldTerm(value);
        if (col !== undefined) {
            return gatedTable !== undefined ? `${gatedTable}.${col}` : col;
        }
    }
    return formatLiteral(value);
}
function formatOperand(operand, gatedTable, bareTopLevel = true) {
    if ('col' in operand) {
        const col = operand.col;
        if (gatedTable !== undefined && !bareTopLevel)
            return `${gatedTable}.${col}`;
        return col;
    }
    if ('lit' in operand)
        return formatTermOrLiteral(operand.lit);
    if ('fn' in operand)
        return 'NULL';
    return 'NULL';
}
function formatTermOrLiteral(value) {
    if (typeof value === 'string' && value.startsWith('$')) {
        if (value === '$author')
            return '$author';
    }
    return formatLiteral(value);
}
function formatCmp(cmp) {
    var _a;
    return (_a = { eq: '=', ne: '!=', lt: '<', le: '<=', gt: '>', ge: '>=' }[cmp]) !== null && _a !== void 0 ? _a : '=';
}
function formatStringPattern(op, sub) {
    const lit = 'lit' in sub && typeof sub.lit === 'string' ? sub.lit : '';
    if (op === 'prefix')
        return sqlString(`${lit}%`);
    if (op === 'suffix')
        return sqlString(`%${lit}`);
    return sqlString(`%${lit}%`);
}
function formatLiteral(value) {
    if (typeof value === 'string')
        return sqlString(value);
    return json.toStringNormalized(value);
}
function sqlString(value) {
    return `'${value.replace(/'/g, "''")}'`;
}
